var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3734 12C3.97251 12 3.62919 11.853 3.34347 11.559C3.05774 11.265 2.91512 10.912 2.9156 10.5V1.5C2.9156 1.0875 3.05847 0.734251 3.34419 0.440251C3.62992 0.146251 3.97299 -0.000498726 4.3734 1.27334e-06H10.9335C11.3344 1.27334e-06 11.6777 0.147001 11.9634 0.441001C12.2492 0.735001 12.3918 1.088 12.3913 1.5V10.5C12.3913 10.9125 12.2484 11.2657 11.9627 11.5597C11.677 11.8537 11.3339 12.0005 10.9335 12H4.3734ZM4.3734 10.5H10.9335V1.5H4.3734V10.5ZM1.4578 15C1.05691 15 0.713594 14.853 0.427865 14.559C0.142137 14.265 -0.000484696 13.912 1.23752e-06 13.5V3.75C1.23752e-06 3.5375 0.0699757 3.35925 0.209925 3.21525C0.349873 3.07125 0.522866 2.9995 0.728901 3C0.935423 3 1.10866 3.072 1.24861 3.216C1.38856 3.36 1.45829 3.538 1.4578 3.75V13.5H8.7468C8.95332 13.5 9.12656 13.572 9.26651 13.716C9.40646 13.86 9.47619 14.038 9.4757 14.25C9.4757 14.4625 9.40573 14.6407 9.26578 14.7847C9.12583 14.9287 8.95284 15.0005 8.7468 15H1.4578Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyPhone);
export default __webpack_public_path__ + "static/media/copy_Phone.0b690fd6.svg";
export { ForwardRef as ReactComponent };